import { FC } from 'react';

import { useI18n } from '#hooks/useI18n';
import { useFormContext } from 'old-rhf';

import { BasePhoneInput, BasePhoneInputProps, getFieldError } from '@zazume/zzm-base';

export interface PhoneInputProps extends Omit<BasePhoneInputProps, 'defaultValue' | 'onChangeValue'> {
  name: string;
  isOptional?: boolean;
}

/**
 * @deprecated This component will be removed after the RHF migration is complete. Use the ZZMForm equivalent from @zazume/zzm-base instead.
 */
export const PhoneInput: FC<PhoneInputProps> = ({ name, isOptional, responsive = false, ...props }) => {
  const { t } = useI18n();
  const {
    register,
    formState: { errors },
    getValues,
    setValue
  } = useFormContext();

  const error = getFieldError(name, errors);

  const defaultValue = getValues(name);
  const onChangeValue = (number: string) => setValue(name, number, { shouldValidate: true });

  const optionalText = isOptional ? t('general.optional') : undefined;

  return (
    <>
      <BasePhoneInput
        {...(props as any)}
        ref={register}
        optionalText={optionalText}
        responsive={responsive}
        onChangeValue={onChangeValue}
        defaultValue={defaultValue}
        error={error}
      />
      <input ref={register} name={name} hidden readOnly />
    </>
  );
};
